import React from 'react'

import Variant from './Variant'

const variants = ['base', 'mini', 'standard', 'full']

const Component = ({
  resource,
  variant,
  selected,
  onChange
}) => {
  const id = `${resource.slug}--${variants[variant]}`
  const level = variants.indexOf(variant)
  const filterVariant = param => param.variant <= level
  const params = resource.params.filter(filterVariant).sort((a,b) => a.variant - b.variant )

  const onToggle = () => onChange(variant)

  return <Variant
    variant={variant}
    id={id}
    onToggle={onToggle}
    selected={selected}
    params={params} />
}

export default Component
export { variants }